import { render, staticRenderFns } from "./FarmFormTemplate.vue?vue&type=template&id=59c74f1e&scoped=true&"
import script from "./FarmFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./FarmFormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./FarmFormTemplate.vue?vue&type=style&index=0&id=59c74f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c74f1e",
  null
  
)

export default component.exports